import { mapGetters } from 'vuex'

export default {
  data() {
    const routes = this.$router.options.routes
    return {
      drawer: true,
      isMini: false,
      hoverGroup: '',
      groupList: [
        {
          isActive: () => this.$route.name?.startsWith('dashboard'),
          meta: [routes.find((route) => route.name === 'dashboard').meta],
          img: {
            close: require('@/assets/icon_dashboard_white.svg'),
            open: require('@/assets/icon_dashboard_blue.svg')
          },
          title: 'common.common_dashboard',
          link: { name: 'dashboard' }
        },
        {
          isActive: () => this.$route.name?.startsWith('kpi'),
          meta: [routes.find((route) => route.name === 'kpi').meta],
          img: {
            close: require('@/assets/icon_dashboard_white.svg'),
            open: require('@/assets/icon_dashboard_blue.svg')
          },
          title: 'common.common_kpi',
          link: { name: 'kpi' }
        },
        {
          isActive: () => this.$route.name?.startsWith('order'),
          meta: [
            routes.find((route) => route.name === 'order.register').meta,
            routes.find((route) => route.name === 'order.history').meta,
            routes.find((route) => route.name === 'order.loading').meta
          ],
          img: {
            close: require('@/assets/icon_order_white.svg'),
            open: require('@/assets/icon_order_blue.svg')
          },
          title: 'common.common_order-loading',
          isOpen: false,
          subGroupList: [
            {
              title: 'common.input_new-order',
              link: { name: 'order.register' },
              meta: routes.find((route) => route.name === 'order.register').meta
            },
            {
              title: 'common.common_loading-order-history',
              link: { name: 'order.history' },
              meta: routes.find((route) => route.name === 'order.history').meta
            },
            {
              title: 'loading.loading_receipt-history',
              link: { name: 'order.loading' },
              meta: routes.find((route) => route.name === 'order.loading').meta
            }
          ]
        },
        {
          isActive: () => this.$route.name?.startsWith('sales'),
          meta: [
            routes.find((route) => route.name === 'sales.register').meta,
            routes.find((route) => route.name === 'sales.history').meta,
            routes.find((route) => route.name === 'sales.ship').meta,
            routes.find((route) => route.name === 'sales.refund.register').meta,
            routes.find((route) => route.name === 'sales.refund.history').meta
          ],
          img: {
            close: require('@/assets/icon_sale_white.svg'),
            open: require('@/assets/icon_sale_blue.svg')
          },
          title: 'common.common_sale-ship',
          isOpen: false,
          subGroupList: [
            {
              title: 'sale.sale_new-sale',
              link: { name: 'sales.register' },
              meta: routes.find((route) => route.name === 'sales.register').meta
            },
            {
              title: 'common.common_ship-sale-history',
              link: { name: 'sales.history' },
              meta: routes.find((route) => route.name === 'sales.history').meta
            },
            {
              title: 'common.common_ship-history',
              link: { name: 'sales.ship' },
              meta: routes.find((route) => route.name === 'sales.ship').meta
            },
            {
              title: 'refund.refund_refund-register',
              link: { name: 'sales.refund.register' },
              meta: routes.find(
                (route) => route.name === 'sales.refund.register'
              ).meta
            },
            {
              title: 'sale.sale_refund-history',
              link: { name: 'sales.refund.history' },
              meta: routes.find(
                (route) => route.name === 'sales.refund.history'
              ).meta
            }
          ]
        },
        {
          isActive: () => this.$route.name?.startsWith('storage'),
          meta: [
            routes.find((route) => route.name === 'storage.register').meta,
            routes.find((route) => route.name === 'storage.history').meta,
            routes.find((route) => route.name === 'storage.adjust.register')
              .meta,
            routes.find((route) => route.name === 'storage.adjust.history')
              .meta,
            routes.find((route) => route.name === 'storage.productStocks').meta
          ],
          img: {
            close: require('@/assets/icon_storage_white.svg'),
            open: require('@/assets/icon_storage_blue.svg')
          },
          title: 'common.common_stock-management',
          isOpen: false,
          subGroupList: [
            {
              title: 'common.common_storage-move',
              link: { name: 'storage.register' },
              meta: routes.find((route) => route.name === 'storage.register')
                .meta
            },
            {
              title: 'storage.storage_storage-move-history',
              link: { name: 'storage.history' },
              meta: routes.find((route) => route.name === 'storage.history')
                .meta
            },
            {
              title: 'common.common_stock-adjust',
              link: { name: 'storage.adjust.register' },
              meta: routes.find(
                (route) => route.name === 'storage.adjust.register'
              ).meta
            },
            {
              title: 'common.common_stock-adjust-history',
              link: { name: 'storage.adjust.history' },
              meta: routes.find(
                (route) => route.name === 'storage.adjust.history'
              ).meta
            },
            {
              title: 'common.common_stock-list',
              link: { name: 'storage.productStocks' },
              meta: routes.find(
                (route) => route.name === 'storage.productStocks'
              ).meta
            }
          ]
        },
        {
          isActive: () => this.$route.name?.startsWith('master'),
          meta: [
            routes.find((route) => route.name === 'master.product').meta,
            routes.find((route) => route.name === 'master.supplier').meta,
            routes.find((route) => route.name === 'master.customer').meta,
            routes.find((route) => route.name === 'master.customerCategory')
              .meta,
            routes.find((route) => route.name === 'master.storage').meta,
            routes.find(
              (route) => route.name === 'master.suggestedReceivingLocation'
            ).meta,
            routes.find((route) => route.name === 'master.stockMoveReason')
              .meta,
            routes.find((route) => route.name === 'master.notePhrase').meta,
            routes.find((route) => route.name === 'master.PaymentMethod').meta,
            routes.find((route) => route.name === 'master.transferAccount').meta
          ],
          img: {
            close: require('@/assets/icon_master_white.svg'),
            open: require('@/assets/icon_master_blue.svg')
          },
          title: 'common.common_master-management',
          isOpen: false,
          subGroupList: [
            {
              title: 'common.common_product',
              link: { name: 'master.product' },
              meta: routes.find((route) => route.name === 'master.product').meta
            },
            {
              title: 'product.product_supplier',
              link: { name: 'master.supplier' },
              meta: routes.find((route) => route.name === 'master.supplier')
                .meta
            },
            {
              title: 'common.common_customer-sale',
              link: { name: 'master.customer' },
              meta: routes.find((route) => route.name === 'master.customer')
                .meta
            },
            {
              title: 'common.common_sale-channel',
              link: { name: 'master.customerCategory' },
              meta: routes.find(
                (route) => route.name === 'master.customerCategory'
              ).meta
            },
            {
              title: 'common.common_storage',
              link: { name: 'master.storage' },
              meta: routes.find((route) => route.name === 'master.storage').meta
            },
            {
              title: 'order.order_suggested-receiving-location',
              link: { name: 'master.suggestedReceivingLocation' },
              meta: routes.find(
                (route) => route.name === 'master.suggestedReceivingLocation'
              ).meta
            },
            {
              title: 'storage.storage_storage-move-reason',
              link: { name: 'master.stockMoveReason' },
              meta: routes.find(
                (route) => route.name === 'master.stockMoveReason'
              ).meta
            },
            {
              title: 'common.common_note-phrase',
              link: { name: 'master.notePhrase' },
              meta: routes.find((route) => route.name === 'master.notePhrase')
                .meta
            },
            {
              title: 'payment.payment_sale-payment-way',
              link: { name: 'master.PaymentMethod' },
              meta: routes.find(
                (route) => route.name === 'master.PaymentMethod'
              ).meta
            },
            {
              title: 'common.common_transfer-account',
              link: { name: 'master.transferAccount' },
              meta: routes.find(
                (route) => route.name === 'master.transferAccount'
              ).meta
            }
          ]
        },
        {
          isActive: () => this.$route.name?.startsWith('csv'),
          meta: [
            routes.find((route) => route.name === 'csv.csvUpload').meta,
            routes.find((route) => route.name === 'csv.csvHistory').meta,
            routes.find((route) => route.name === 'csv.jdProduct').meta,
            routes.find((route) => route.name === 'csv.shop').meta
          ],
          img: {
            close: require('@/assets/icon_csv_white.svg'),
            open: require('@/assets/icon_csv_blue.svg')
          },
          title: 'common.common_csv-upload',
          isOpen: false,
          subGroupList: [
            {
              title: 'common.common_csv-upload',
              link: { name: 'csv.csvUpload' },
              meta: routes.find((route) => route.name === 'csv.csvUpload').meta
            },
            {
              title: 'common.common_csv-history-view',
              link: { name: 'csv.csvHistory' },
              meta: routes.find((route) => route.name === 'csv.csvHistory').meta
            },
            {
              title: 'jd.jd_jdcom-product-management',
              link: { name: 'csv.jdProduct' },
              meta: routes.find((route) => route.name === 'csv.jdProduct').meta
            },
            {
              title: 'jd.jd_jdcom-store-management',
              link: { name: 'csv.shop' },
              meta: routes.find((route) => route.name === 'csv.shop').meta
            }
          ]
        },
        {
          isActive: () => this.$route.name?.startsWith('nextengine'),
          meta: [
            routes.find((route) => route.name === 'nextengine.ecGoodsList')
              .meta,
            routes.find(
              (route) => route.name === 'nextengine.ecReceiveorderList'
            ).meta,
            routes.find((route) => route.name === 'nextengine.configEdit').meta
          ],
          img: {
            close: require('@/assets/icon_form_white.svg'),
            open: require('@/assets/icon_form_blue.svg')
          },
          title: 'nextengine.nextengine_cooperate-title',
          isOpen: false,
          subGroupList: [
            {
              title: 'nextengine.nextengine_ec-goods-list',
              link: { name: 'nextengine.ecGoodsList' },
              meta: routes.find(
                (route) => route.name === 'nextengine.ecGoodsList'
              ).meta
            },
            {
              title: 'nextengine.nextengine_ec-receiveorder-list',
              link: { name: 'nextengine.ecReceiveorderList' },
              meta: routes.find(
                (route) => route.name === 'nextengine.ecReceiveorderList'
              ).meta
            },
            {
              title: 'nextengine.nextengine_cooperate-config',
              link: { name: 'nextengine.configEdit' },
              meta: routes.find(
                (route) => route.name === 'nextengine.configEdit'
              ).meta
            }
          ]
        },
        {
          isActive: () => this.$route.name === 'ledgerSheet',
          meta: [routes.find((route) => route.name === 'ledgerSheet').meta],
          img: {
            close: require('@/assets/icon_form_white.svg'),
            open: require('@/assets/icon_form_blue.svg')
          },
          title: 'common.common_form',
          link: { name: 'ledgerSheet' }
        },
        {
          isActive: () => this.$route.name === 'closingMonth',
          meta: [routes.find((route) => route.name === 'closingMonth').meta],
          img: {
            close: require('@/assets/icon_setting_white.svg'),
            open: require('@/assets/icon_setting_blue.svg')
          },
          title: 'common.common_tightening-process',
          link: { name: 'closingMonth' }
        }
      ],
      isSubscribeList: {
        icon1: false,
        icon2: false,
        icon3: false,
        icon4: false,
        icon5: false
      },
      isNextengineCooperate: false
    }
  },
  computed: {
    ...mapGetters('User', ['authority', 'getUserInfoFromState'])
  },
  updated() {
    const organizationInfo = this.getUserOrganizationInfo()
    if (organizationInfo != undefined) {
      this.isSubscribeList.icon1 = organizationInfo.isSubscribe1
      this.isSubscribeList.icon2 = organizationInfo.isSubscribe2
      this.isSubscribeList.icon3 = organizationInfo.isSubscribe3
      this.isSubscribeList.icon4 = organizationInfo.isSubscribe4
      this.isSubscribeList.icon5 = organizationInfo.isSubscribe5
      this.isNextengineCooperate = organizationInfo.isNextengineCooperate
        ? true
        : false
    }
  },
  methods: {
    getUserOrganizationInfo() {
      return this.getUserInfoFromState.organization
    },
    setHoverGroup(group) {
      this.hoverGroup = group
    },
    closeGroupList() {
      for (const group in this.groupList) {
        if (
          Object.prototype.hasOwnProperty.call(this.groupList[group], 'isOpen')
        ) {
          this.$set(this.groupList[group], 'isOpen', false)
        }
      }
    },
    subscribeIconUrl(iconFileName) {
      let url = ''
      switch (process.env.VUE_APP_ENV_NAME) {
        case 'production':
          url = 'https://order-assets.spe-s.com/subscribe_icons/'
          break
        case 'staging':
          url = 'https://stg-order-assets.spe-s.com/subscribe_icons/'
          break
        default:
          url = 'https://dev-order-assets.spe-s.com/subscribe_icons/'
      }
      return url + iconFileName
    },
    calcMarginBottomSize() {
      let size = 56
      if (this.isSubscribeList.icon1) {
        size += 45
      }
      if (this.isSubscribeList.icon2) {
        size += 45
      }
      if (this.isSubscribeList.icon3) {
        size += 45
      }
      if (this.isSubscribeList.icon4) {
        size += 45
      }
      if (this.isSubscribeList.icon5) {
        size += 45
      }
      return size + 'px'
    },
    checkPermission(meta, isParent) {
      const userAuthorityId = this.authority?.id

      // isParentフラグでメイングループかサブグループかを判断
      if (isParent) {
        // --- メイングループの処理 ---
        // metaはサブ項目のmetaオブジェクトの配列です。
        // 表示可能なサブ項目が1つでもあればメイングループを表示します。
        return meta.some((subMeta) => {
          // subMetaが存在しない場合はチェックをスキップします。
          if (!subMeta) return true

          // ネクストエンジン連携に関する画面項目かチェックします。
          if (subMeta.isNextengine && !this.isNextengineCooperate) {
            // 組織がネクストエンジン連携していない場合は非表示にします。
            return false
          }

          // 権限をチェックします。
          const permissions = subMeta.permissions || []
          // 権限設定がないか、ユーザーの権限が含まれていれば表示します。
          return (
            permissions.length === 0 || permissions.includes(userAuthorityId)
          )
        })
      } else {
        // --- サブグループの処理 ---
        // metaは単一のmetaオブジェクトです。
        // metaが存在しない場合は表示します。
        if (!meta) return true

        // ネクストエンジン連携に関する画面項目かチェックします。
        if (meta.isNextengine && !this.isNextengineCooperate) {
          // 組織がネクストエンジン連携していない場合は非表示にします。
          return false
        }

        // 権限をチェックします。
        const permissions = meta.permissions || []
        // 権限設定がないか、ユーザーの権限が含まれていれば表示します。
        return permissions.length === 0 || permissions.includes(userAuthorityId)
      }
    }
  }
}
